import { PositionReward } from "@silo/types";
import { Align, Breakdown } from "./components";

interface BreakdownProtectedProps {
  className?: string;
  protectedRewards: PositionReward[];
  align: Align;
}

export function BreakdownProtected({
  className,
  protectedRewards,
  align,
}: BreakdownProtectedProps): JSX.Element {
  return (
    <Breakdown.Root className={className} align={align}>
      <Breakdown.Item>
        <Breakdown.ItemValue>--</Breakdown.ItemValue>

        <Breakdown.ItemLabel>deposit APR</Breakdown.ItemLabel>
      </Breakdown.Item>

      {protectedRewards.map((reward) => (
        <Breakdown.DepositRewardItem reward={reward} />
      ))}
    </Breakdown.Root>
  );
}
